import { queryClient } from "../../../middlewares/cacheing/QueryClient.middleware";
import accountService from "../../../services/accounts/account.service";
import { accountActionTypes } from "../../actionTypes/accounts/account.actionTypes";
import { orderActionTypes } from "../../actionTypes/orders/order.actionTypes";

export const login = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: accountActionTypes.START_LOGIN });

    const response = await accountService.login(credentials);
    const token = response.data.payload;
    dispatch({
      type: accountActionTypes.LOGIN_SUCCESS,
      data: token,
    });
    // Save the token to local storage
    localStorage.setItem("jwtToken", token);
    return response.data;
  } catch (ex) {
    console.log("Login error: " + ex.message);
    const errorResponse = ex.response?.data;
    dispatch({ type: accountActionTypes.LOGIN_FAILURE, error: errorResponse });
    return errorResponse;
  }
};

export const registerBusiness = (userDetails) => async (dispatch) => {
  try {
    dispatch({ type: accountActionTypes.START_REGISTER_BUSINESS });

    const response = await accountService.registerBusiness(userDetails);
    const token = response.data.payload;
    dispatch({
      type: accountActionTypes.REGISTER_BUSINESS_SUCCESS,
      data: token,
    });
    // Save the token to local storage
    localStorage.setItem("jwtToken", token);
    return response.data;
  } catch (ex) {
    console.log("Register BUSINESS error: " + ex.message);
    const errorResponse = ex.response?.data;
    dispatch({
      type: accountActionTypes.REGISTER_BUSINESS_FAILURE,
      error: errorResponse,
    });
    return errorResponse;
  }
};

export const resetUserPassword = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: accountActionTypes.START_RESET_USER_PASSWORD });

    const response = await accountService.resetUserPassword(credentials);
    dispatch({ type: accountActionTypes.RESET_USER_PASSWORD_SUCCESS });
  } catch (ex) {
    console.log("reset user password error: " + ex.message);
    dispatch({ type: accountActionTypes.RESET_USER_PASSWORD_FAILURE, error: ex.response?.data });
  }
};

export const changeUserPassword = (data) => async (dispatch) => {
  try {
    dispatch({ type: accountActionTypes.START_CHANGE_USER_PASSWORD });

    const response = await accountService.changeUserPassword(data);
    dispatch({ type: accountActionTypes.CHANGE_USER_PASSWORD_SUCCESS });
  } catch (ex) {
    console.log("change user password error: " + ex.message);
    dispatch({ type: accountActionTypes.CHANGE_USER_PASSWORD_FAILURE, error: ex.response?.data });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("jwtToken");
  dispatch({ type: accountActionTypes.LOGOUT });
  dispatch({ type: orderActionTypes.CLEAR_ORDERS }); // Clear orders

  // ✅ Invalidate orders cache to ensure fresh data on next login
  queryClient.invalidateQueries({ queryKey: ["business-orders"] });
};

export const getUserInfo = (data) => async (dispatch) => {
  try {
    dispatch({ type: accountActionTypes.START_GET_USER_INFO });

    const response = await accountService.getUserInfo(data);
    dispatch({
      type: accountActionTypes.GET_USER_INFO_SUCCESS,
      data: response.data.payload,
    });
  } catch (ex) {
    console.log("Get user info error: " + ex.message);
    dispatch({
      type: accountActionTypes.GET_USER_INFO_FAILURE,
      error: ex.response?.data,
    });
  }
};

export const getUsersByBusinessCustomer = () => async (dispatch) => {
  try {
    dispatch({ type: accountActionTypes.START_GET_USERS_BY_BUSINESS });

    const response = await accountService.getUsersByBusinessCustomer();
    const users = response.data.payload;

    dispatch({
      type: accountActionTypes.GET_USERS_BY_BUSINESS_SUCCESS,
      data: users,
    });

    return users; // Return users for further processing if needed
  } catch (ex) {
    console.log("Get users by business customer error: " + ex.message);
    const errorResponse = ex.response?.data;

    dispatch({
      type: accountActionTypes.GET_USERS_BY_BUSINESS_FAILURE,
      error: errorResponse,
    });

    return errorResponse; // Return error for further processing if needed
  }
};

export const deleteAccount = (email) => async (dispatch) => {
  try {
    dispatch({ type: accountActionTypes.START_DELETE_ACCOUNT });

    const response = await accountService.deleteAccount(email);

    dispatch({
      type: accountActionTypes.DELETE_ACCOUNT_SUCCESS,
      data: email,
    });

    return response.data; // Return success response
  } catch (ex) {
    console.log("Delete account error: " + ex.message);
    const errorResponse = ex.response?.data;

    dispatch({
      type: accountActionTypes.DELETE_ACCOUNT_FAILURE,
      error: errorResponse,
    });

    return errorResponse; // Return error response
  }
};

const accountActions = {
  login,
  registerBusiness,
  resetUserPassword,
  changeUserPassword,
  logout,
  getUserInfo,
  getUsersByBusinessCustomer,
  deleteAccount,
};

export default accountActions;
